import { render, staticRenderFns } from "./data-lake-report-chart.vue?vue&type=template&id=24896ade&scoped=true"
import script from "./data-lake-report-chart.ts?vue&type=script&lang=ts&external"
export * from "./data-lake-report-chart.ts?vue&type=script&lang=ts&external"
import style0 from "./data-lake-report-chart.scss?vue&type=style&index=0&id=24896ade&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24896ade",
  null
  
)

export default component.exports